import { PrivilegedStatus } from '@/entities/card';
import { getPrivilegeInfoAsync, queryConsumeCountAsync } from '@/services/card';
import { query } from './util';

const WAIT_TIME = 5000;

export const sleep = (timeout = 100) => new Promise((resolve) => {
  setTimeout(resolve, timeout);
});

export class Polling {
  stop = false;
  constructor() {
  }
  stopPolling() {
    console.log('🚀 ~ Polling ~ stopPolling ~ this.stop:', this.stop);
    this.stop = true;
  }
  startPolling: (request: () => any, times: number) => any = async (request: () => any, times: number) => {
    console.log('🚀 ~ file: polling.ts:12 ~ constpolling: ~ times:', times, this.stop);
    if (times <= 0 || this.stop) {
      console.log('🚀 ~ Polling ~ startPolling: ~ times: stop', times);
      return false;
    }

    if (times === 20 && query('debug') === '1') {
      return {
        status: true,
        privilegeInfo: {
          name: '',
          status: 1,
          type: 0,
          autopay_type: 0,
          start_time: '1686298938',
          end_time: '1800745654',
          product_id: '',
          enquity_type: 1,
        },
      };
    }

    const result = await request();
    if (result.status) {
      return result;
    }

    await sleep(WAIT_TIME);
    return this.startPolling(request, times - 1);
  };
}

// 轮询函数
export const polling: (request: () => any, times: number) => any = async (request: () => any, times: number) => {
  console.log('🚀 ~ file: polling.ts:12 ~ constpolling: ~ times:', times);
  if (times <= 0) {
    return false;
  }

  if (times === 20 && query('debug') === '1') {
    return {
      status: true,
      privilegeInfo: {
        name: '',
        status: 1,
        type: 0,
        autopay_type: 0,
        start_time: '1686298938',
        end_time: '1800745654',
        product_id: '',
        enquity_type: 1,
      },
    };
  }

  const result = await request();
  if (result.status) {
    return result;
  }

  await sleep(WAIT_TIME);
  return polling(request, times - 1);
};


// 检查会员状态
export const checkOrder = async (ts: any, vipEndTs: any) => {
  const {
    cards,
  } = await getPrivilegeInfoAsync();
  const privilegeInfo = cards?.[0];
  const { endTime = 0, status = 0 } = privilegeInfo || {};
  console.log('🚀 ~ file: polling.ts:33 ~ checkOrder ~ privilegeInfo:', privilegeInfo);
  if (vipEndTs) {
    return {
      status: status === PrivilegedStatus.VIP && Number(endTime) > Number(vipEndTs),
      privilegeInfo,
    };
  }
  return {
    status: status === PrivilegedStatus.VIP && Number(endTime) >= Number(ts),
    privilegeInfo,
  };
};

// 检查单次购买状态
export const checkConsumeCount = async (otLeftTime: any, otIsPaid: any) => {
  console.log('🚀 ~ checkConsumeCount ~ otIsPaid:', otIsPaid);
  const {
    leftTime,
    isPaid,
  } = await queryConsumeCountAsync();
  console.log('🚀 ~ checkConsumeCount ~ isPaid:', isPaid);
  console.log('🚀 ~ checkConsumeCount ~ leftTime:', leftTime);
  if (!otIsPaid && isPaid) {
    return {
      status: true,
    };
  }
  if (otIsPaid && isPaid) {
    return {
      status: Number(leftTime) > Number(otLeftTime),
    };
  }
  return {
    status: false,
  };
};

